/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MultiPageMenu',['pixi', 'absolute/button', 'absolute/screenmetrics', 'lodash',
        'absolute/pageindicator', 'absolute/coords', 'absolute/platform', 'absolute/stringmanager',
    'absolute/audiomanager'],

    function (PIXI, Button, ScreenMetrics,  _, PageIndicator, Coords, Platform, _s, AudioManager) {

        var MultiPageMenu = function (ui, options) {

            var defaultOptions = {
                pages: [],
                pagePadding: {x: Coords.x(90), y: Coords.y(180)},
                borderThickness: {left: Coords.x(0), right: Coords.x(0)},
                interfacePadding: {arrows: {x:Coords.x(10),y:Coords.y(25)}, pips: Coords.y(25)},
                buttonScale: 1,
                pageButtonImage: 'btn_arrow_ring.png',
                pageChangedCallback: function(){},
                startPage: 0,
                width: Coords.x(1920),
                height: Coords.x(1080),
                letterStyle: {
                    font: ScreenMetrics.getResScale() * 34 + 'px segoe2',
                    tint: 0xffffff,
                    align: 'left'
                }
            };

            this.initMultiPageMenu(ui, _.extend(defaultOptions, options));
        };

        MultiPageMenu.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        MultiPageMenu.prototype.initMultiPageMenu = function (ui, options) {

            PIXI.DisplayObjectContainer.call(this);

            this.ui = ui;
            this.options = options;

            this.nextPage = 0;
            this.pageChangedHandler = null;

            this.container = new PIXI.DisplayObjectContainer();
            this.buttonContainer = new PIXI.DisplayObjectContainer();
            this.addChild(this.container);

            this.pages = this.options.pages;
            var startPage = this.options.startPage < this.pages.length ? this.options.startPage : 0;

            this.reset(false, startPage);
        };

        MultiPageMenu.prototype.reset = function (cleanUp, startPage, newPages) {

            if(cleanUp) {
                try {
                    this.removeChild(this.pageTray);
                    this.removeChild(this.pips);
                    this.removeChild(this.nextpageButton);
                    this.removeChild(this.prevpageButton);
                } catch (e) {}
            }

            if(newPages) {
                this.options.pages = newPages;
                this.pages = newPages;
            }

            this.initContent();
            this.initNonTouchInterface();
            if(!Platform._isOldAndroid()) {
                this.initTouchInterface();
            }
            this.initPagePips();

            this.scrollToPage(startPage, false);

            this.addChild(this.buttonContainer);

        };

        MultiPageMenu.prototype.initContent = function() {

            var totalWidth = 0;

            this.pagePositions = [];
            this.pageTray = new PIXI.DisplayObjectContainer();

            for (var i = 0, l = this.pages.length; i < l; i += 1) {
                var page = this.pages[i];
                page.x = (i * this.options.width) + this.options.pagePadding.x;
                //page.x = totalWidth + i * this.options.pagePadding.x;
                page.y = this.options.pagePadding.y;
                this.pageTray.addChild(page);
                totalWidth += page.width;
                this.pagePositions.push(page.x);
            }

            this.kPanThreshold = this.options.width / 5;

            this.centerOffset = (this.options.width - this.pages[0].width)/2;
            this.pageTray.position.x = this.centerOffset;

            var mask = new PIXI.Graphics();
            mask.beginFill(0xFFFFFF, 1.0);
            mask.drawRect(this.position.x + this.options.borderThickness.left, this.position.y,
                this.options.width - this.options.borderThickness.right, this.options.height);
            mask.endFill();
            this.pageTray.mask = mask;

            this.container.addChild(this.pageTray);

        };

        MultiPageMenu.prototype.initTouchInterface = function() {

            // Dragging and panning
            this.lastDeltaX = 0;
            this.startX = 0;
            var hitArea = new PIXI.Rectangle(this.options.pagePadding.x, 0, this.options.width - this.options.pagePadding.x * 2, this.options.height - Coords.y(75));
            this.touchContainer = new PIXI.DisplayObjectContainer();
            this.touchContainer.interactive = true;
            this.touchContainer.hitArea = hitArea;
            this.touchContainer.addChild(this.pageTray);
            this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
            this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
            this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend = this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
            this.addChild(this.touchContainer);

        };

        MultiPageMenu.prototype.initNonTouchInterface = function() {

            this.labelPadding = Coords.x(14);

            /*this.nextpageLabel = new PIXI.BitmapText('', this.options.letterStyle);
            this.prevpageLabel = new PIXI.BitmapText('', this.options.letterStyle);
            this.nextpageLabel.updateText();
            this.nextpageLabel.interactive = true;
            this.nextpageLabel.buttonMode = true;
            this.prevpageLabel.interactive = true;
            this.prevpageLabel.buttonMode = true;

            this.nextpageLabel.hitArea = new PIXI.Rectangle(0,0,Coords.x(400), Coords.x(50));
            this.prevpageLabel.hitArea = new PIXI.Rectangle(0,0,Coords.x(400), Coords.x(50));*/

            this.nextpageButton = new Button(
                PIXI.Texture.fromFrame(this.options.pageButtonImage),
                PIXI.Texture.fromFrame(this.options.pageButtonImage),
                this.scrollNextPage.bind(this),
                false
            );
            //var buttonY = this.options.height - (this.nextpageButton.height * this.options.buttonScale) - this.options.interfacePadding.arrows.y;
            var buttonY = this.ui.height/2 - this.nextpageButton.height / 2;
            this.nextpageButton.scale.x = -1 * this.options.buttonScale;
            this.nextpageButton.scale.y = this.options.buttonScale;
            this.nextpageButton.position.x = this.options.width - this.options.interfacePadding.arrows.x;
            this.nextpageButton.position.y = buttonY;
            this.nextpageButton.setActive(false);
            //this.nextpageLabel.x = this.nextpageButton.x + this.nextpageButton.width - this.nextpageLabel.width - this.labelPadding;
            //this.nextpageLabel.y = buttonY - this.labelPadding / 2;
            this.buttonContainer.addChild(this.nextpageButton);
            //this.container.addChild(this.nextpageLabel);
            //this.nextpageLabel.mousedown = this.nextpageLabel.touchstart = this.nextpageButton.action;

            this.prevpageButton = new Button(
                PIXI.Texture.fromFrame(this.options.pageButtonImage),
                PIXI.Texture.fromFrame(this.options.pageButtonImage),
                this.scrollPrevPage.bind(this),
                false
            );
            this.prevpageButton.position.y = buttonY;
            this.prevpageButton.scale.x = this.prevpageButton.scale.y = this.options.buttonScale;
            this.prevpageButton.position.x = this.options.interfacePadding.arrows.x;
            this.prevpageButton.setActive(false);
            //this.prevpageLabel.x = this.prevpageButton.x + this.prevpageButton.width + this.labelPadding;
            //this.prevpageLabel.y = buttonY - this.labelPadding / 2;
            this.buttonContainer.addChild(this.prevpageButton);
            //this.container.addChild(this.prevpageLabel);
            //this.prevpageLabel.mousedown = this.prevpageLabel.touchstart = this.prevpageButton.action;

        };

        MultiPageMenu.prototype.scrollNextPage = function (playSound) {
            if (this.currentPage < this.pages.length - 1) {
                this.scrollToPage(this.currentPage + 1, true, playSound);
                return true;
            }
            return false;
        };

        MultiPageMenu.prototype.scrollPrevPage = function (playSound) {
            if (this.currentPage > 0) {
                this.scrollToPage(this.currentPage - 1, true, playSound);
                return true;
            }
            return false;
        };

        MultiPageMenu.prototype.initPagePips = function() {
            if(this.pages.length > 1) {
                this.pips = new PageIndicator(this.pages.length, 0, _.extend(this.options, {clickCallback: function(index) {
                    this.scrollToPage(index, true, true);
                }.bind(this)}));
                this.pips.position.x = (this.options.width - this.pips.totalWidth) / 2;
                this.pips.position.y = this.options.height - this.pips.totalHeight - this.options.interfacePadding.pips;
                this.pips.scale.x = this.pips.scale.y = 1;
                this.container.addChild(this.pips);
            }
        };

        MultiPageMenu.prototype.handleDragStart = function (data) {
            this.dragging = true;
            this.lastDeltaX = 0;
            this.startX = data.getLocalPosition(this.parent).x;
            this.enableButtons(false);
        };

        MultiPageMenu.prototype.handleDrag = function (data) {

            if(!this.dragging) {
                return;
            }

            var pos = data.getLocalPosition(this.parent),
                delta = pos.x - this.startX;

            this.pageTray.x += ((delta - this.lastDeltaX) * ScreenMetrics.devicePixelRatio) * 0.7;

            this.lastDeltaX = delta;
        };

        MultiPageMenu.prototype.handleDragEnd = function (data) {

            this.dragging = false;

            this.lastDeltaX = 0;

            if(typeof this.parent == 'undefined') {
                return;
            }

            var pageIndex = this.currentPage,
                pos = data.getLocalPosition(this.parent),
                delta = pos.x - this.startX;

            if (delta <= -this.kPanThreshold) {
                pageIndex += 1;
            } else if (delta >= this.kPanThreshold) {
                pageIndex -= 1;
            }

            if(pageIndex < 0) {
                pageIndex = 0;
            } else if (pageIndex > this.pages.length - 1) {
                pageIndex = this.pages.length - 1;
            }

            window.setTimeout(function(){
                if(_.isNumber(pageIndex)) {
                    this.scrollToPage(pageIndex);
                }
            }.bind(this), 0);

        };

        MultiPageMenu.prototype.setPageChangedHandler = function (handler) {
            this.pageChangedHandler = handler;
        };

        MultiPageMenu.prototype.scrollToPage = function(pageIndex, tween, playSound) {

            playSound = !!playSound

            if (typeof tween == 'undefined') {
                tween = true;
            }

            if(this.pips) {
                this.pips.setPageIndex(pageIndex);
            }

            var pageWidth = this.pages[pageIndex].width,
                destination,
                self = this;

            // use this offset if the desired affect is a centered page
            //this.centerOffset = (this.options.width - pageWidth)/2;
            this.centerOffset = this.options.pagePadding.x;
            destination = - this.pagePositions[pageIndex] + this.centerOffset;
            var prevPage = this.currentPage;

            if(playSound) {
                AudioManager.playSound('button');
            }

            if (tween) {
                new TWEEN.Tween({ x: this.pageTray.position.x })
                    .to({ x: destination }, 200)
                    .easing(TWEEN.Easing.Quadratic.InOut)
                    .onUpdate(function () {
                        self.pageTray.position.x = this.x;
                    })
                    .onComplete(function () {
                        self.enableButtons(true);
                        self.setCurrentPage(pageIndex);
                        if (typeof self.pageChangedHandler == 'function') {
                            self.pageChangedHandler(prevPage, self.currentPage);
                        }
                    })
                    .start();
            }
            else {
                this.pageTray.position.x = destination;
                this.enableButtons(true);
                this.setCurrentPage(pageIndex);
                if (typeof self.pageChangedHandler == 'function') {
                    this.pageChangedHandler(prevPage, this.currentPage);
                }
            }
        };

        MultiPageMenu.prototype.setCurrentPage = function (page) {

            var nextPageOn = page !== this.pages.length - 1,
                prevPageOn = page !== 0;

            this.currentPage = page;
            this.nextpageButton.setActive(nextPageOn);
            this.prevpageButton.setActive(prevPageOn);
            
            /*this.nextpageButton.visible = this.nextpageLabel.visible = page !== this.pages.length - 1;
            this.prevpageButton.visible = this.prevpageLabel.visible = page !== 0;*/

            this.nextpageButton.alpha = nextPageOn ? 1 : 0.3
            this.prevpageButton.alpha = prevPageOn ? 1 : 0.3;



            // required if labels are needed
            /*
             this.nextpageButton.visible = page !== this.pages.length - 1;
             this.prevpageButton.visible = page !== 0;
            if(this.nextpageButton.visible) {
                this.nextpageLabel.setText(this.pages[this.currentPage + 1].displayName || _s('buttons.next'));
                this.nextpageLabel.updateText();
                this.nextpageLabel.x = this.nextpageButton.x + this.nextpageButton.width - this.nextpageLabel.width - this.labelPadding;
            }
            if(this.prevpageButton.visible) {
                this.prevpageLabel.setText(this.pages[this.currentPage - 1].displayName || _s('buttons.previous'));
                this.prevpageLabel.updateText();
                this.prevpageLabel.x = this.prevpageButton.x + this.prevpageButton.width + this.labelPadding;
            }*/

            this.options.pageChangedCallback(page);
        };

        MultiPageMenu.prototype.enableButtons = function (enable) {

            var i, l;

            for (i = 0, l = this.pages.length; i < l; i++) {
                this.pages[i].interactive = enable;
            }

        };

        /*MultiPageMenu.prototype.handleOrientationChange = function (isPortrait) {

            this.scale.x = this.scale.y = 1;
            this.reset(true, this.currentPage);

        };*/

        return MultiPageMenu;

    });


